import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-work-details-page',
  templateUrl: './work-details-page.component.html',
  styleUrls: ['./work-details-page.component.scss']
})
export class WorkDetailsPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
